import { useState } from "react";
import { AuthModal } from "@/components/auth/AuthModal";
import { useLandingRedirect } from "@/hooks/useLandingRedirect";
import { LandingSEO } from "@/components/seo";
import ReferringIsSimple from "@/pages/landing/ReferringIsSimple";
import WhyAirtalentMakesADifference from "@/pages/landing/WhyAirtalentMakesADifference";
import ProvenResults from "@/pages/landing/ProvenResults";
import Footer from "@/pages/landing/Footer";
import { LoadingScreen } from "@/components/ui/LoadingScreen";
import { LandingHeader } from "@/components/landing/LandingHeader";
import Hero from "./landing/Hero";
import FAQ from "./landing/FAQ";
import Contact from "./landing/contact";

export default function Landing() {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const { shouldShowLanding, isRedirecting } = useLandingRedirect();

  if (isRedirecting || !shouldShowLanding) {
    return <LoadingScreen text="Loading..." />;
  }

  return (
    <>
      <LandingSEO />
      
      <div className="min-h-screen relative">
        <LandingHeader onLoginClick={() => setAuthModalOpen(true)} />
        <div id="home">
          <Hero setAuthModalOpen={setAuthModalOpen} />
        </div>
        <div id="how-it-works">
          <ReferringIsSimple setAuthModalOpen={setAuthModalOpen} />
        </div>
        <div id="why-airtalent">
          <WhyAirtalentMakesADifference />
          <ProvenResults />
        </div>
        <div id="faq">
          <FAQ />
        </div>
        <div id="contact">
          <Contact />
        </div>
        <Footer />
      </div>
      <AuthModal open={authModalOpen} onOpenChange={setAuthModalOpen} />
    </>
  );
}
